'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tetherToggle = require('./tether-toggle');

var _tetherToggle2 = _interopRequireDefault(_tetherToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _tetherToggle2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/tether-toggle/index.js
 ** module id = 773
 ** module chunks = 0 1
 **/